<template>
  <div class="interaction-body display-maximum free-response free-response-display-maximum">
    <text-box
      v-if="feedback.length"
      color-key="feedback"
      title="Feedback"
      :text="feedback"
      :indent="false"
      tabindex="0"
      :aria-label="`Interaction answer feedback: ${feedback.length ? feedback.stripHTML(['img', 'Image']) : ''}`"
      :attachments="localInteraction.interactionFeedbackAttachments"
    ></text-box>
  </div>
</template>

<script>
import _ from 'lodash';
import TextBox from '../../Snippets/TextBox.vue';
import Interaction from '../../../mixins/Interaction';

export default {
  name: 'FreeResponseDisplayMaximumInteractionBody',
  components: {
    TextBox,
  },
  mixins: [
    Interaction,
  ],
  computed: {
    feedback() {
      return _.get(this, 'localInteraction.config.feedback', '');
    },
  },
};
</script>
